import { EventClientSectionComponent } from '../../../content/events/event/event-clients/event-client-section/event-client-section.component';
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { EventsService } from '../../../api/events.service';
import { NGXLogger } from 'ngx-logger';
import { FuseTranslationLoaderService } from '../../../../../@fuse/services/translation-loader.service';
import { ClientsService } from '../../../api/clients.service';
import { GT2PageAbstract } from '../../../content/abstract/GT2PageAbstract';
import { locale as english } from './i18n/en-CA';
import { locale as french } from './i18n/fr-CA';
import { fromEvent, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { ProjectsService } from '../../../api/projects.service';
import { CreateClientEnterprisePanelService } from '../../../services/create-client-enterprise-panel.service';
import { CreateEnterprisePanelService } from '../../../services/create-enterprise-panel.service';
import { CreateClientPanelService } from '../../../services/create-client-panel.service';
import { SelectClientPanelService } from '../../../services/select-client-panel.service';
import { CommonModule } from '@angular/common';
import { MatRadioModule } from '@angular/material/radio';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Router } from '@angular/router';

@Component({
  selector: 'app-select-client',
  templateUrl: './select-client.component.html',
  styleUrls: ['./select-client.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatRadioModule,
    MatInputModule,
    MatIconModule,
    ScrollingModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    MatTooltipModule,
    MatButtonModule,
    TranslateModule,
  ],
})
export class SelectClientComponent
  extends GT2PageAbstract
  implements OnInit, AfterViewInit, OnDestroy
{
  clients!: any[];
  eventUUID!: string;
  projectUUID!: string;
  clientSection!: string;
  filterValue: string = '';
  selectedClient: any;
  isLoading: boolean = false;
  isEmpty: boolean = true;
  @ViewChild('filter') filter!: ElementRef;
  fromEventSubscription!: Subscription;
  clientFor!: string;
  clientType: string = 'client';

  constructor(
    private panelService: SelectClientPanelService,
    private translationLoader: FuseTranslationLoaderService,
    public translate: TranslateService,
    private logger: NGXLogger,
    public dialog: MatDialog,
    public router: Router,
    private clientsService: ClientsService,
    private eventsService: EventsService,
    private projectsService: ProjectsService,
    private createClientEnterprisePanelService: CreateClientEnterprisePanelService,
    private createEnterprisePanelService: CreateEnterprisePanelService,
    private createClientPanelService: CreateClientPanelService,
  ) {
    super();
    this.translationLoader.loadTranslations(english, french);
    const data = this.panelService.getData();
    if (data?.eventUUID) {
      this.eventUUID = data.eventUUID;
    }

    if (data?.projectUUID) {
      this.projectUUID = data.projectUUID;
    }

    if (data?.clientSection) {
      this.clientSection = data.clientSection;
    }

    if (data?.client) {
      this.selectedClient = data.client;
    }

    if (data?.clientFor) {
      this.clientFor = data.clientFor;
    }
  }

  public close(): void {
    this.panelService.emitResult(false);
  }

  ngOnInit() {
    if (this.selectedClient) {
      this.filterValue =
        this.selectedClient.first_name + ' ' + this.selectedClient.last_name;
    }

    this.loadClientList();
  }

  ngAfterViewInit() {
    this.fromEventSubscription = fromEvent(this.filter?.nativeElement, 'keyup')
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        tap(() => {
          // //this.logger.info("SelectClientComponent.onFilterChange() -> " + this.productList);
          //this.logger.info("SelectClientComponent.onFilterChange() -> " + this.filterValue);
          //   if (this.filterValue.length >= 3 )
          //   {
          //     this.loadClientList();
          //   }
          //   else
          //   {
          //     this.clients = [];
          //     this.isEmpty = true;
          //   }
          this.loadClientList();
          /*
                        if (this.filterValue.length >= 3 || this.filterValue === "")
                        {
                          this.loadProductList();
                        }
              */
          // this.productList.nativeElement.scrollTop = 0;
        }),
      )
      .subscribe();
  }

  ngOnDestroy() {}

  public trackByUUID(index: any, item: any) {
    return item.uuid;
  }

  public onSelectClient(item: any): void {
    //this.logger.info("SelectClientComponent.onSelectClient()");
    this.selectedClient = item;
    //this.logger.info("SelectClientComponent.onSelectClient() -> this.selectedClient: " + JSON.stringify(this.selectedClient));
  }

  public onClientSelected(): void {
    //this.logger.info("SelectClientComponent.onClientSelected() -> this.clientFor: " + this.clientFor);
    this.isLoading = true;
    //
    // if (this.clientFor === EventClientSectionComponent.CLIENT_FOR_EVENT) {
    //     this.addClientToEvent();
    // } else if (
    //     this.clientFor === EventClientSectionComponent.CLIENT_FOR_PROJECT
    // ) {
    //     this.addClientToProject();
    // }
    if (this.clientFor === EventClientSectionComponent.CLIENT_FOR_PROJECT) {
      this.addClientToProject();
    } else {
      this.addClientToEvent();
    }
  }

  public onSameClientForBoth(): void {
    //this.logger.info("SelectClientComponent.onSameClientForBoth()");
    this.isLoading = true;

    if (this.clientFor === EventClientSectionComponent.CLIENT_FOR_PROJECT) {
      this.addSameClientToProjectBothSections();
    } else {
      this.addSameClientToEventBothSections();
    }
  }
  public addClientToEvent(): void {
    //this.logger.info("SelectClientComponent.addClientToEvent()");
    this.eventsService
      .addClient(this.selectedClient.uuid, this.eventUUID, this.clientSection)
      .subscribe({
        next: (response: any) => {
          // //this.logger.info("SelectClientComponent.onClientSelected() -> SUCCESS: " + JSON.stringify(response));
          this.isLoading = false;
          this.isEmpty = false;
          this.panelService.emitResult(response);
        },
        error: (error: any) => {
          //this.logger.info("SelectClientComponent.onClientSelected() -> ERROR: " + JSON.stringify(error));
          this.isLoading = false;
          this.isEmpty = true;
          this.handleAPIError(error, this.dialog, null, null, this.router);
        },
      });
  }

  public addClientToProject(): void {
    //this.logger.info("SelectClientComponent.addClientToProject()");
    this.projectsService
      .addClient(this.selectedClient.uuid, this.projectUUID, this.clientSection)
      .subscribe({
        next: (response: any) => {
          // //this.logger.info("SelectClientComponent.onClientSelected() -> SUCCESS: " + JSON.stringify(response));
          this.isLoading = false;
          this.isEmpty = false;
          this.panelService.emitResult(response);
        },
        error: (error: any) => {
          //this.logger.info("SelectClientComponent.onClientSelected() -> ERROR: " + JSON.stringify(error));
          this.isLoading = false;
          this.isEmpty = true;
          this.handleAPIError(error, this.dialog, null, null, this.router);
        },
      });
  }

  public addSameClientToEventBothSections(): void {
    //this.logger.info("SelectClientComponent.addSameClientToEventBothSections()");
    // First call - add to ordering
    this.eventsService
      .addClient(this.selectedClient.uuid, this.eventUUID, 'ordering')
      .subscribe({
        next: () => {
          // Second call - add to invoicing
          this.eventsService
            .addClient(this.selectedClient.uuid, this.eventUUID, 'invoicing')
            .subscribe({
              next: (invoicingResponse: any) => {
                this.isLoading = false;
                this.isEmpty = false;
                this.panelService.emitResult(invoicingResponse);
              },
              error: (error: any) => {
                //this.logger.info("SelectClientComponent.addSameClientToEventBothSections() -> ERROR on invoicing: " + JSON.stringify(error));
                this.isLoading = false;
                this.isEmpty = true;
                this.handleAPIError(
                  error,
                  this.dialog,
                  null,
                  null,
                  this.router,
                );
              },
            });
        },
        error: (error: any) => {
          //this.logger.info("SelectClientComponent.addSameClientToEventBothSections() -> ERROR on ordering: " + JSON.stringify(error));
          this.isLoading = false;
          this.isEmpty = true;
          this.handleAPIError(error, this.dialog, null, null, this.router);
        },
      });
  }

  public addSameClientToProjectBothSections(): void {
    //this.logger.info("SelectClientComponent.addSameClientToProjectBothSections()");
    // First call - add to ordering
    this.projectsService
      .addClient(this.selectedClient.uuid, this.projectUUID, 'ordering')
      .subscribe({
        next: () => {
          // Second call - add to invoicing
          this.projectsService
            .addClient(this.selectedClient.uuid, this.projectUUID, 'invoicing')
            .subscribe({
              next: (invoicingResponse: any) => {
                this.isLoading = false;
                this.isEmpty = false;
                this.panelService.emitResult(invoicingResponse);
              },
              error: (error: any) => {
                //this.logger.info("SelectClientComponent.addSameClientToProjectBothSections() -> ERROR on invoicing: " + JSON.stringify(error));
                this.isLoading = false;
                this.isEmpty = true;
                this.handleAPIError(
                  error,
                  this.dialog,
                  null,
                  null,
                  this.router,
                );
              },
            });
        },
        error: (error: any) => {
          //this.logger.info("SelectClientComponent.addSameClientToProjectBothSections() -> ERROR on ordering: " + JSON.stringify(error));
          this.isLoading = false;
          this.isEmpty = true;
          this.handleAPIError(error, this.dialog, null, null, this.router);
        },
      });
  }

  public clearSearch(): void {
    this.filterValue = '';
    // this.clients = [];
    // this.isLoading = false;
    // this.isEmpty = true;
    this.loadClientList();
  }

  public loadClientList(): void {
    if (this.clientType == 'enterprise') {
      this.loadEnterprisesClientsList();
    } else {
      this.loadOnlyClientsList();
    }
  }

  public loadOnlyClientsList(): void {
    this.isLoading = true;
    this.isEmpty = false;
    this.clientsService.getAllClientsCC(this.filterValue).subscribe({
      next: (response) => {
        //this.logger.info("SelectClientComponent.constructor() -> SUCCESS: " + JSON.stringify(response));
        this.clients = response.data;
        this.isLoading = false;
        this.isEmpty = this.clients?.length === 0;
      },
      error: (error) => {
        this.logger.error(
          'SelectClientComponent.constructor() -> ERROR: ' +
            JSON.stringify(error),
        );
        this.handleAPIError(error, this.dialog, null, null, this.router);
        this.isLoading = false;
        this.isEmpty = true;
      },
    });
  }

  public loadEnterprisesClientsList(): void {
    this.isLoading = true;
    this.isEmpty = false;
    this.clientsService.getAllEnterprisesClients(this.filterValue).subscribe({
      next: (response) => {
        // //this.logger.info("SelectClientComponent.constructor() -> SUCCESS: " + JSON.stringify(response));
        this.clients = response.data;
        this.isLoading = false;
        this.isEmpty = this.clients?.length === 0;
      },
      error: (error) => {
        this.logger.error(
          'SelectClientComponent.constructor() -> ERROR: ' +
            JSON.stringify(error),
        );
        this.handleAPIError(error, this.dialog, null, null, this.router);
        this.isLoading = false;
        this.isEmpty = true;
      },
    });
  }

  public reloadClients(event: any): void {
    this.clientType = event;
    //this.logger.info("SelectClientComponent.reloadClients");
    this.loadClientList();
  }

  public onCreateClient(): void {
    this.logger.debug('SelectClientComponent.onCreateClient()');

    this.createClientPanelService
      .open({ navigateToClient: false })
      .subscribe({
        next: (result: any) => {
          if (result) {
            this.selectedClient = result;
            this.onClientSelected();
          }
        },
      });
  }

  public onCreateEnterprise(): void {
    this.logger.debug('ClientComponent.onCreateEnterprise()');

    this.createEnterprisePanelService.open().subscribe({
      next: (_result: any) => {
        // No-op: matches prior dialog.afterClosed() behavior for this caller.
      },
    });
  }

  public onCreateClientEnterprise(): void {
    this.logger.debug('ClientComponent.onCreateClientEnterprise()');

    this.createClientEnterprisePanelService.open().subscribe({
      next: (result: any) => {
        if (result) {
          // Parent select-client stays open; no action needed today —
          // matches the previous dialog.afterClosed() no-op behavior.
        }
      },
    });
  }
}
